import { NextLink } from '../commonComponents/NextLink'

import ImageWithBasePath from './ImageWithBasePath'
import { useRouterHook } from '../hooks/useRouterHook'
import { useContext } from 'react'
import { SharedContext } from '@/context/SharedContext'

export const DefaultHeader = ({ title, backNavigation, isComponent = false }) => {
  const { navigateToPagesInSeeker } = useRouterHook()
  const { location } = useContext(SharedContext)

  const navigateToHome = () => {
    if (isComponent) {
      backNavigation()
      return true
    }
  }

  const NavigateBack = () => {
    if (title === 'Sponsored Jobs') {
      navigateToPagesInSeeker({
        pathName: `jobsFiltering`,
        as: `jobs-in-${(location?.title || location?.name).toLowerCase()}`
      })
    } else if ((location?.title || location?.name) && title !== 'Sponsored Jobs') {
      navigateToPagesInSeeker({
        pathName: `seekerHomePage`,
        as: `${(location?.title || location?.name).toLowerCase()}`
      })
    } else {
      navigateToPagesInSeeker({
        pathName: `seekerHomePage`,
        as: '/'
      })
    }
  }

  return (
    <div className="flex cursor-pointer items-center space-x-[8px] pl-[12px]">
      <div
        id="defalut_header_navigation"
        className="flex h-fit w-fit cursor-pointer items-center"
        onClick={() => NavigateBack()}
      >
        <ImageWithBasePath src="navigationIcon" width={24} height={24} alt="back arrow symbol" />
      </div>
      <NextLink
        href="seekerHomePage"
        as={location ? `jobs/${location?.name || location?.title}` : '/jobs'}
        isLoader={false}
        id="defalut_header_logo"
        className="relative h-[24px] w-[24px]"
        onClick={navigateToHome}
      >
        <ImageWithBasePath src="logo_lokal" width={24} height={24} alt="logo of Lokal" />
      </NextLink>
      <div
        id="default_header_title"
        className="select-none truncate text-ellipsis font-noto-sans text-md font-normal leading-[21.79px] text-[#323234]"
      >
        {title}
      </div>
    </div>
  )
}
